import 'src/pages/track/track-page.css';
import { TOURNAMENTS_TABLE } from 'src/common/constants/elementConstants';
import { SPLASH, TOURNAMENT, TOURNAMENTS, TRACK } from 'src/common/constants/routerConstants';
import { toggleLanguageDropdown } from 'src/services/languageService';
import { tournamentFramework } from 'src/pages/tournament/framework';
import { toggleTheme } from 'src/services/themeService';
import { context } from 'src/common/context';
import { t } from 'src/i18n/i18n';

export function rootBlock() {
  const main = document.createElement('div');
  main.className = 'main noselect';

  const nav = document.createElement('nav');
  nav.className = 'navbar';
  const navBrand = document.createElement('div');
  navBrand.className = 'navbar-brand';
  const navItem = document.createElement('div');
  navItem.onclick = () => {
    if (context.providerAbbr) {
      context.router.navigate(`/tournaments/${context.providerAbbr}`);
    }
  };
  navItem.className = 'navbar-item provider-back';
  navItem.id = 'back';

  const navEnd = document.createElement('div');
  navEnd.className = 'navbar-end';

  const themeToggle = document.createElement('button');
  themeToggle.className = 'navbar-item theme-toggle';
  themeToggle.title = t('theme.toggleDark');
  const updateIcon = () => {
    const isDark = document.documentElement.dataset.theme === 'dark';
    themeToggle.textContent = isDark ? '\u2600' : '\u263E';
  };
  updateIcon();
  themeToggle.onclick = () => {
    toggleTheme();
    updateIcon();
  };
  navEnd.appendChild(themeToggle);

  const langButton = document.createElement('button');
  langButton.className = 'navbar-item language-toggle';
  langButton.title = t('language.select');
  langButton.textContent = '\uD83C\uDF10';
  langButton.onclick = () => toggleLanguageDropdown(langButton);
  navEnd.appendChild(langButton);

  const isLocal = ['localhost', '127.0.0.1', '[::1]'].includes(globalThis.location.hostname);
  const userButton = document.createElement('button');
  userButton.className = 'navbar-item user-login';
  userButton.title = t('Login');
  userButton.textContent = '\uD83D\uDC64';
  userButton.style.display = isLocal ? '' : 'none';
  navEnd.appendChild(userButton);

  navBrand.appendChild(navItem);
  nav.appendChild(navBrand);
  nav.appendChild(navEnd);
  main.appendChild(nav);

  const splash = document.createElement('div');
  splash.style.display = 'none';
  splash.id = SPLASH;

  const tournaments = document.createElement('div');
  tournaments.style.display = 'none';
  tournaments.id = TOURNAMENTS;

  const tTable = document.createElement('div');
  tTable.id = TOURNAMENTS_TABLE;
  tournaments.appendChild(tTable);

  const tournament = document.createElement('div');
  tournament.style.display = 'none';
  tournament.id = TOURNAMENT;
  tournament.appendChild(tournamentFramework());

  const track = document.createElement('div');
  track.style.display = 'none';
  track.id = TRACK;

  main.appendChild(tournaments);
  main.appendChild(tournament);
  main.appendChild(track);
  main.appendChild(splash);

  return main;
}
